import React, { useEffect, useState } from "react";
import "../../../../assets/scss/home.scss";
import "../../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Card, CardBody } from "reactstrap";
import Spinner from "../../../../@core/components/spinner/Fallback-spinner";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Row, Col } from "reactstrap";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import Repository from "../../../../configs/axios/repository";
import { filterFlashcardJson } from "../../../../utility/helpers/filterJson";
import { handleGetFlashcard } from "../../../../redux/layout";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import ProgressBar from "@ramonak/react-progress-bar";
import logo from "@src/assets/images/smartStudyLogo.svg";
import Swal from "sweetalert2";

const CreateFlashcard = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const locationState = useLocation();
    let notes = locationState.state?.notes;
    let note_id = locationState.state?.note_id;
    let noteData = locationState.state?.noteData;
    let showLimit = locationState.state?.showLimit;
    let isDataFlash = locationState.state?.isDataFlash;

    let canDoIt = localStorage.getItem("canDoIt");
    const [location, setLocation] = useState(locationState.state?.note_id);
    const [showNotes, setShowNotes] = useState(false);
    const [showPrompt, setShowPrompt] = useState(false);
    const [loadingData, setLoadingData] = useState(true);
    const [prompt, setPrompt] = useState("");
    const [showTiket, setShowTiket] = useState();
    const [isData, setIsData] = useState(false);

    const [collCount, setCollCount] = useState(0);

    let count = 1;
    let processValue = 10;

    const process = (values) => {
        if (count < 10) {
            setLoadingData(false);
            count = count + 1;
            processValue = processValue + 10;
            setCollCount(processValue);
            hendleNext(values);
        } else {
            setCollCount(100);
            setLoadingData(true);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "There is something wrong with the prompt. Please change it and try again.!",
                confirmButtonText: "Regenerate",
            }).then((result) => {
                if (result.isConfirmed) {
                    processValue = 10;
                    setCollCount(0);
                    hendleNext(values);
                } else {
                    history.push({
                        pathname: "/home",
                    });
                }
            });
        }
    };

    const toAccountingFlashcardPage = (values, array, modifiedText) => {
        let flashData = {
            flashcard_name: values.flashcard_name,
            icon: "",
            note_id: {
                note_id: location.note_id ? location.note_id : location,
            },
            no_of_questions: null,
            flashcard_content: JSON.stringify(array),
            notes: modifiedText,
        };
        dispatch(handleGetFlashcard(JSON.stringify(flashData)));
        localStorage.setItem("isCreateTest", true);
        history.push({
            pathname: "/accountingFlashcard",
            state: { array, flashData, isData, noteData },
        });
    };
    const hendleNext = async (values) => {
        let modifiedText = notes.replace(/\\"/g, '"');
        setLoadingData(false);
        setTimeout(() => {
            setCollCount(processValue);
        }, 1000);
        let data = {
            count: null,
            messages: modifiedText,
        };

        const result = await Repository.postRequest(
            `api/flashcards/getChatCompletion`,
            data
        );

        // setLoadingData(true);
        if (result.data.success == false) {
            setLoadingData(false);
        }

        setPrompt(result.data.data.getChatCompletionData);

        const array = filterFlashcardJson(
            result.data.data.getChatCompletionData
        );

        if (array == "error" || array[0] == undefined) {
            process(values);
        } else {
            setCollCount(100);

            setTimeout(() => {
                toAccountingFlashcardPage(values, array, modifiedText);
            }, 2000);
        }
    };

    const getFlashcard = async () => {
        const result = await Repository.findByEndPoint(
            `api/flashcards/getFlashcard`
        );
        if (result.data?.data[0] != undefined) {
            setIsData(true);
            localStorage.setItem("showTiketDetail", false);
        } else {
            setIsData(false);
        }
        return result.data?.data[0]?.length;
    };

    useEffect(async () => {
        localStorage.setItem("isCreate", true);
        getFlashcard();
    }, []);

    useEffect(async () => {
        if (!isDataFlash) {
            hendleNext(notes);
        }
    }, []);
    useEffect(() => {
        let isDatas = localStorage.getItem("showTiketFlashcard");
        if (isDatas == "true" || isDatas == null || isDatas == undefined) {
            setShowTiket(true);
            localStorage.setItem("showTiketFlashcard", true);
        } else {
            setShowTiket(false);
        }
    }, []);
    return loadingData ? (
        <div className="mt-4"></div>
    ) : (
        <div>
            <div className="fallback-spinner app-loader progres">
                <img className="fallback-logo" src={logo} alt="logo" />
                <div className="loading loadingDiv">
                    <div className="effect-1 effects"></div>
                    <div className="effect-2 effects"></div>
                    <div className="effect-3 effects"></div>
                </div>
                <ProgressBar completed={collCount} />
            </div>
        </div>
    );
};

export default CreateFlashcard;
